import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomepageRoutingModule } from './homepage-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HomepageRoutingModule
  ]
})
export class HomepageModule { }

/**
 * Modal for Request of product by gender suppliment 
 */
export class MGenderSupplimentRequest {
  take!: number;
  skip!: number;
  gender!: string;
  is_suppliment!:boolean
}

 /**
 * Modal for Response of product by gender suppliment 
 */
export class MGenderSupplimentResponse {
  statusCode!: number;
  message!: string;
  data: any = [MGenderSupplimentResponseData];
  token!: string;
  totalRecords!:number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

 /**
 * Modal of  product by gender suppliment  Response Data
 */
export class MGenderSupplimentResponseData {
  id!: number
  category_id!: number
  sub_category_id!: number
  warehouse_id!: number
  brand_id!: number
  name!: string
  description!: string
  product_code!: string
  hsn!: string
  list_price!: number
  your_price!: number
  stock!: number
  minimum_qty!: number
  order_amount!: number
  handling_fee!: number
  sku!: number
  gender!:number 
  size!: number
  alert_threshold!: number
  thumbnail_img!: string
  created_by!: string
  modified_by!:string
  created_at!:string
  modified_at!: string
  is_suppliment!: boolean
  product_sale_type!: string
  skin_concerns!: string
  skin_type!: string
  free_from!: string
  why!: string
  who!: string
  expiry_date!: string
  country_of_origin!: string
  key_ingridents!: string
  when_to_use_it!: string
  how_to_use_it!: string
  video_url!: string
  is_active!: boolean
  is_deleted!: boolean
  imageList?: any
  discountList?: any
  extras!:[MExtraProduct]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Request of  Tending  product  
 */
export class MTrendingProductRequest {
  take!: number;
  skip!: number;
  trendingBy!: string;
}

 /**
 * Modal for Response of Trending product 
 */
export class MTrendingProductResponse {
  statusCode!: number;
  message!: string;
  data: any = [MTrendingProductResponseData];
  token!: string;
  totalRecords!:number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
 /**
 * Modal of Trending Product Response Data
 */
 export class MTrendingProductResponseData {
  id!: number
  order_id!: string
  category_id!: number
  category!: string
  sub_category_id!: number
  sub_category!: string
  warehouse_id!: number
  brand_id!: number
  brand!: string
  name!: string
  description!: string
  additional_description!: string
  product_code!: string
  hsn!: string
  list_price!: number
  your_price!: number
  order_amount!: number
  handling_fee!: number
  sku!: string
  gender!: string
  size!: string
  color!: string
  thumbnail_img!: string
  is_suppliment!: boolean
  skin_concerns!: string
  skin_type!: string
  why!: string
  who!: string
  benifits!: string
  expiry_date!: string
  country_of_origin!: string
  key_ingridents!: string
  when_to_use_it!: string
  how_to_use_it!: string
  click_count!: number
  video_url!: string
  image1!: string
  image2!: string
  image3!: string
  image4!: string
  image5!: string
  extras!:[MExtraProduct]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Banner image list Response
 */
export class MBannerImageListRequest {
  type!: string;
  code!: string;
}

/**
 * Modal for Banner image list Response
 */
export class MBannerImageListResponse {
  statusCode!: number;
  message!: string;
  data: any = [MBannerImageListResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal of Banner image Response Data
 */
export class MBannerImageListResponseData {
  id!: number;
  type!: string;
  code!: string;
  is_default!: boolean
  path!: string;
  created_by!: string;
  modified_by!: string;
  created_at!: string;
  modified_at!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Category Response Data
 */
export class MCustomerMenuCategoryResponse{
  category_id?:number
  category_name?: string
  created_at?: string
  created_by?: string
  description?: string
  id?: number
  imageList?: string
  is_active?:boolean
  modified_at?: string
  modified_by?: string
  name?: string
  skip?:number
  sub_category_code?: string
  take?:number
  thumbnail_img?: string
  subCategoriesList?:[MCustomerMenuSubcategoryResponse]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Sub Category Response Data
 */
export class MCustomerMenuSubcategoryResponse{
  id!: number
  category_id!:number
  name!: string
  description!:string
  sub_category_code!: string
  thumbnail_img!: string
  productList!: [MCustomerMenuProductListResponse]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Product List Response Data
 */
export class MCustomerMenuProductListResponse{
  threshold!: any
  brand!: any
  brand_id! :number
  category! :any
  category_id! : number
  country_of_origin!: string
  created_at!: any
  created_by! : any
  description! : string
  discountList! : any
  expiry_date! :any
  freeFroms! : any
  free_from! : number
  gender!:number
  genderString!: string
  handling_fee!:number
  how_to_use_it! :string 
  hsn!: number
  id!: number
  imageList!: any
  is_active! :boolean
  is_deleted!: string 
  is_suppliment!:any
  key_ingridents!: any
  list_price!: number
  minimum_qty!:number
  modified_at!:any
  modified_by!:any
  name!: string
  order_amount!:number
  product_code!: string
  product_sale_type!: string
  size!: string
  skinConcerns! :any
  skinTypes!: any
  skin_concerns!:number
  skin_type!:string
  sku!: string
  stock!: number
  subCategory!: any
  sub_category_id!: number
  video_url!: string
  warehouse!:any
  warehouse_id!:number
  when_to_use_it!:string
  who!: string
  why!:string
  your_price!: number
  extras!:[MExtraProduct]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
export class MExtraProduct {
  id!: number
  sku!: string
  size!: string
  list_price!: number
  your_price!: number
  order_amount!: number
constructor(values: Object = {}) {
  Object.assign(this, values);
}
}
/**
 * Modal for Brand Response Data
 */
export class MBrandResponse{
  created_at!:string
  created_by!:string
  description!:string
  id!:number
  imageList!:string
  is_active!:boolean
  modified_at!:string
  modified_by!:string
  name!:string
  thumbnail_img!:string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Category Response Data
 */
export class MCategoryResponse{
  category_code!:string
  created_at!:string
  created_by!:string
  description!:string
  gender!:number
  id!:number
  is_active!:boolean
  is_blog!:boolean
  modified_at!:string
  modified_by!:string
  name!:string
  skin_concern_title!:string
  skin_type_title!:string
  thumbnail_img!:string
  type!:number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Free From Response Data
 */
export class MFreeFromResponse{
  created_at!:string
  created_by!:string
  id!:number
  is_active!:boolean
  modified_at!:string
  modified_by!:string
  name!:string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for SkinConsern Response Data
 */
export class MSkinConsernResponse{
  category!:string
  category_id!:number
  created_at!:string
  created_by!:string
  id!: number
  is_active!:boolean
  modified_at!:string
  modified_by!:string
  name!:string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for SkinType Response Data
 */
export class MSkinTypeResponse{
  category!:string
  category_id!:number
  created_at!:string
  created_by!:string
  id!:number
  is_active!:boolean
  modified_at!:string
  modified_by!:string
  name!:string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for WareHouse Response Data
 */
export class MWareHouseResponse{
  address_line1!:string
  address_line2!:string
  city!:string
  country_id!:number
  country_name!:string
  created_at!:string
  created_by!:string
  description!:string
  id!:number
  is_active!:boolean
  latitude!:string
  location!:string
  longitude!:string
  modified_at!:string
  modified_by!:string
  name!:string
  pincode!:number
  state_id!:number
  state_name!:string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Banner image list Response
 */
export class MGetAllTagsResponse {
  statusCode!: number;
  message!: string;
  data: any = [MGetAllTagResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
 
export class MGetAllTagResponseData {
  id!: number;
  title!: string;
  totalRecords!: number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
